import {isObject} from 'lodash';

type DeepDiffOptions = {
  label1: string;
  label2: string;
};

export function deepDiff(
  current: Record<string, unknown>,
  expected: Record<string, unknown>,
  options?: DeepDiffOptions
) {
  const diffs: Record<string, unknown> = {};

  function compareObjects(objA: Record<string, unknown>, objB: Record<string, unknown>, path: string) {
    for (const key in objA) {
      if (Object.prototype.hasOwnProperty.call(objA, key)) {
        const newPath = path ? `${path}.${key}` : key;

        if (Object.prototype.hasOwnProperty.call(objB, key)) {
          if (isObject(objA[key]) && isObject(objB[key])) {
            compareObjects(objA[key] as Record<string, unknown>, objB[key] as Record<string, unknown>, newPath);
          } else {
            if (objA[key] !== objB[key]) {
              diffs[newPath] = {[options?.label1 ?? 'objA']: objA[key], [options?.label2 ?? 'objB']: objB[key]};
            }
          }
        } else {
          diffs[newPath] = {[options?.label1 ?? 'objA']: objA[key], [options?.label2 ?? 'objB']: undefined};
        }
      }
    }
  }

  compareObjects(current, expected, '');

  for (const key in expected) {
    if (Object.prototype.hasOwnProperty.call(expected, key) && !Object.prototype.hasOwnProperty.call(current, key)) {
      diffs[key] = {[options?.label1 ?? 'objA']: undefined, [options?.label2 ?? 'objB']: expected[key]};
    }
  }

  return diffs;
}
